<template>
  <div id="chartKLine" class="chart"></div>
</template>

<script>
export default {
  props: ['stockCode', 'stockName', 'historyData'],
  data() {
    return {
      factorId: '',
      repDate: '',
      freq:'',
      indexName: '',
      chartLineDate: [], // 折线时间
      // chartLineData: [], // 折线数值
      chartLineAll: [],  // 折线时间和数值
      chartKDate: [], // K线时间
      // chartKData: [],  // K线数值
      chartKAll: [], // K线时间和数值
      chartKLDate: [],  // 合并后的时间
      chartKLData1: [], // 合并后的折线数值
      chartKLData2: [], // 合并后的K线数值
      triggerDate: [],
      triggerX: '', // 触发日期坐标x的值
      triggerY: '', //触发日期坐标y的值
      chartDom: '',
      themeStyleVs: ''
    }
  },
  created() {
    this.token = this.$route.query.token
    // this.token = this.$store.state.token
    this.themeStyleVs = this.$route.query.themeStyleVs
    this.factorId = this.$route.query.indexId
    this.repDate = this.$route.query.date
    this.freq = this.$route.query.freq
    this.indexName = this.$route.query.indexName
    this.getLineData()
  },
  watch: {
    stockCode() {
      this.chartDom.clear();
      this.getKData()
    }
  },
  methods: {
    // 获取折线数据
    getLineData () {
      var postParam = {
        qid: new Date().getTime(),
        param: {
          factorId: this.factorId,
          repDate: this.repDate
        }
      }
      this.$http({
        method:'post',
        url: window.config.research_server + '/research-framework-server/rf/fm/idx/fvs',
        data: postParam,
        headers: {
          token: this.token
        }
      }).then((res) =>{
        var result = []
        if (res.data.data.length > 0) {
          result = res.data.data
          result.forEach(element => {
            if(element.v !='' && element.v != undefined) {
              this.chartLineAll.push(element)
            }
          })
          this.chartLineAll.forEach(element=>{
            this.chartLineDate.push(element.t)
          })
          this.getKData()
        }
      })
    },
    // 获取K线数据
    getKData() {
      this.chartKAll = []
      this.chartKDate = []
      this.chartKLData1 = []
      this.chartKLData2 = []
      // var date = new Date()
      //  日、周、月：日线       // 季、半年、年：月线
      //   if (this.freq == 86400 || this.freq == 604800 || this.freq == 2592000) {
      //   date.setMonth(date.getMonth() - 12)
      //   date.toLocaleDateString()
      // } else {
      //   date.setMonth(date.getMonth() - 36)
      //   date.toLocaleDateString()
      // }
      var params = {
        obj: this.stockCode.toString(),
        period: '1day',
        filed: 'KaiPanJia,ShouPanJia,ZuiDiJia,ZuiGaoJia',
        begin_time: this.getToday(this.chartLineDate[0])
      }
      window.dzhyun.query("/quote/kline", params, (res)=>{
        this.chartKAll = res[0].Data
        this.chartKAll.forEach(element=>{
          // var arr = []
          element.ShiJian  = this.getToday(element.ShiJian * 1000, '-') // 转为年-月-日
          this.chartKDate.push(element.ShiJian)
        })
        this.getIndexTriggerDate()
      })
    },
    // 获取指标触发日期
    getIndexTriggerDate() {
      var postParam = {
        qid: new Date().getTime(),
        param: {
          indexId: this.factorId,
          date: this.repDate
        }
      }
      this.$http({
        method: 'post',
        url: window.config.research_server + '/research-framework-server/report/indexTriggerDate',
        data: postParam,
        headers: {
          token: this.token
        }
      }).then(res=> {
        if (res.data.code == 0 && res.data.data) {
          this.triggerDate = res.data.data
        }
        this.drawKLine()
      })
    },
    drawKLine() {
      // this.chartDom = []
      // K线和折线 date合并去重
      var dateAll = [...this.chartLineDate, ...this.chartKDate]
      dateAll.forEach(element=>{
        if (this.chartKLDate.indexOf(element) == -1) {
          this.chartKLDate.push(element)
        }
      })
      this.chartKLDate.sort((a, b)=> {
        return Date.parse(a) - Date.parse(b) // 按时间戳排序
      })
      this.chartKLDate.forEach(element=>{
        var lineItem = null
        var KItem = []
        // 补齐折线数据
        this.chartLineAll.forEach(element2 =>{
          if(element == element2.t) {
            lineItem = this.toFixed(element2.v)
          }
          // 最新报告期坐标Y
        if(element2.t == this.repDate) {
          this.triggerY = element2.v
        }
        })
        // 补齐K线数据
        this.chartKAll.forEach(element2 =>{
          if(element == element2.ShiJian) {
            KItem[0] = element2.KaiPanJia
            KItem[1] = element2.ShouPanJia
            KItem[2] = element2.ZuiDiJia
            KItem[3] = element2.ZuiGaoJia
          }
        })
        // 最新报告期坐标X
        if(element == this.repDate) {
          this.triggerX = element
        }
        this.chartKLData1.push(lineItem)
        this.chartKLData2.push(KItem)
      })
      this.$nextTick(()=>{
        if (!this.chartDom) {
        this.chartDom = this.$echarts.init(document.getElementById('chartKLine'))
      } else {
          this.chartDom.dispose()
          this.chartDom = this.$echarts.init(document.getElementById('chartKLine'))
      }
      // 默认展示246条数据
      var start = Math.floor((1 - 246/this.chartKLDate.length) * 100)
       var dataZoom =
      [{
        type: 'inside',
        start,
        end: 100,
      }, {
        type: 'slider',
        start,
        end: 100,
        left: 7,
        right: 12,
        brushSelect: false,
        handleSize: 20,
        handleIcon: this.themeStyleVs == 1 ?  "image://images/handle.png" : "image://images/handle-black.png",
        handleStyle: {
          color: '#fff'
        },
        height: 20,
        backgroundColor: this.themeStyleVs == 1 ? "rgba(250, 250, 250, 1)" : 'rgba(30, 32, 43, 1)',
        borderColor: this.themeStyleVs == 1 ? "rgba(250, 250, 250, 1)" : 'rgba(30, 32, 43, 1)'
      }]
      var option = {
        grid:{
          top: 30,
          bottom: 40,
          left: 50,
          right: 30
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // type: 'cross'
          },
          formatter: (params=>{
            // console.log(params)
            var paramsLine = params[1]
            var paramsK = params[0]
            var lineData = (paramsLine.value !=undefined) ? paramsLine.value : '--'
            var value = paramsK.axisValue + '<br/>' + paramsK.seriesName + '<br/>开盘价：' + (paramsK.data[1] ? paramsK.data[1] : '--')+ '<br/>收盘价：'+ (paramsK.data[2] ? paramsK.data[2] : '--') + '<br/>最低价：' + (paramsK.data[3] ? paramsK.data[3]: '--')+ '<br/>最高价：' +  (paramsK.data[4] ? paramsK.data[4]: '--') + '</br>指标：' + lineData
            return value
          })
        },
        xAxis: [
          { // 指标提示提示icon
            position: 'bottom',
            offset: 15,
            type: 'category',
            data: this.chartKLDate,
            axisLabel: {
              show: true,
              color: 'rgba(0,0,0,0.4)',
              formatter: (value)=> {
                if (this.triggerDate.indexOf(value) !=-1) {
                  return '{tip|}'
                } else {
                  return ''
                }
              },
              rich: {
                tip: {
                  width: 12,
                  height: 12,
                  align: "top",
                  backgroundColor: {
                    image: this.themeStyleVs == 1 ? "images/axis-tip.png" : "images/axis-tip-black.png",
                  },
                }
              }
            },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
          },
          {
            position: 'bottom',
            type: 'category',
            data: this.chartKLDate,
            axisLabel: {
              fontSize: 11,
              margin: 10,
              show: true,
              color: this.themeStyleVs == 1 ? 'rgba(0,0,0,0.3)' : 'rgba(255, 255, 255, 0.4)',
            },
            axisLine: {
              lineStyle: {
                color: this.themeStyleVs == 1 ? 'rgba(0,0,0,0.05)' : 'rgba(0,0,0,0)',
                width: 0.5,
                show: false
              }
            },
            axisTick: {
              lineStyle: {
                color: this.themeStyleVs == 1 ?  'rgba(0,0,0,0.1)' : 'rgba(237, 237, 237, 0.08)',
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            splitLine:{
              show: true,
              lineStyle:{
                color: this.themeStyleVs == 1 ?  'rgba(0,0,0,0.1)' : 'rgba(0,0,0,0)',
                // color: 'red',
                width: 0.5
              }
            },
            axisLabel: {
              color: this.themeStyleVs == 1 ?  'rgba(0,0,0,0.3)' : 'rgba(255, 255, 255, 0.4)',
              formatter: function (value) {
                return value.toFixed(2);
              },
              fontSize: 10,
              margin: 5
            },
            max: function (value) {
              return Math.floor(value.max) + 2;
            },
            min: function (value) {
              return Math.floor(value.min) - 2;
            }
          },
          {
            name: '元',
            nameTextStyle: {
              color: this.themeStyleVs == 1 ? 'rgba(0,0,0,0.25)' : 'rgba(255, 255, 255, 0.4)',
              fontSize: 10,
              align: 'left',
              padding: [0,0,0,7]
            },
            type: 'value',
            splitLine:{
              show: false
            },
            axisLabel: {
              color: this.themeStyleVs == 1 ? 'rgba(0,0,0,0.3)' : 'rgba(255, 255, 255, 0.4)',
              fontSize: 10,
              margin: 5
            },
            max: function (value) {
              return Math.floor(value.max) + 1;
            },
            min: function (value) {
              return Math.floor(value.min) - 1;
            }
          }
        ],
        series: [
          {
            type: 'candlestick',
            name: this.stockName,
            data: this.chartKLData2,
            yAxisIndex: 1,
          },
          {
            data: this.chartKLData1,
            name: '指标',
            type: 'line',
            symbolSize: 0,
            lineStyle: {
              width: 2,
              color: this.themeStyleVs == 1 ? '#286DF7' : '#3B85FE'
            },
            connectNulls: true,
             markPoint: {
              symbol: "circle",
              symbolSize: 5,
              itemStyle: {
                color: "#fff",
                borderColor: '#286DF7',
                borderWidth: 2,
                shadowColor: "rgba(255, 255, 255, 0.5)",
                shadowBlur: 2,
              },
              label: {
                show: this.historyData.length > 0 ? true : false,
                position: 'insideRight',
                fontSize: 11,
                backgroundColor: this.themeStyleVs == 1 ? "rgba(0, 0, 0, 0.50)" : 'rgba(255, 255, 255, 0.5)',
                color: this.themeStyleVs == 1 ? "#E5EEFF" : '#222222',
                padding: 8,
                borderRadius: 4,
                formatter: this.historyData.length > 0 ? "连续"+this.historyData[0].latestNFreq+"期累计涨幅大于"+this.toFixed(this.historyData[0].latestValue)+"%":'',
              },
              data: [
                {
                  coord: [this.triggerX.toString(), this.triggerY.toString()],
                },
              ],
            },
          }

        ]
      }
      if (this.chartKLDate.length > 246) { // 超过246条，出现滚动条
          option.dataZoom = dataZoom
          option.grid.bottom = 75
        }
      this.chartDom.setOption(option)
      })

    },
  },
}
</script>

<style lang="scss" scoped>
  .chart{
    width: 100%;
    height: 100%;
  }
</style>